<template>
  <div>
    <div class="content_top_search">
      <div class="content_top_search_label">模版分类：</div>
      <div class="content_top_search_list">
        <div
          class="content_top_search_list_item"
          :class="{ active: value === null }"
          @click="categoryClick(null)"
        >
          全部
        </div>
        <div
          class="content_top_search_list_item"
          v-for="item in categoryList"
          :key="item.categoryId"
          :class="{ active: item.categoryId === value }"
          @click="categoryClick(item.categoryId)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      categoryList: [],
    };
  },
  created() {
    this.getContractTempCategoryList();
  },
  computed: {},
  methods: {
    async getContractTempCategoryList() {
      const { status, data } = await this.$api.getContractTempCategory();
      if (status === 200) {
        this.categoryList = data;
      }
    },
    // 分类点击
    categoryClick(id) {
      this.$emit("input", id);
      this.$emit("change", id);
    },
  },
};
</script>

<style scoped lang="scss">
.content_top_search {
  display: flex;
  align-items: center;
  &_label {
    font-size: 14px;
    font-weight: 350;
    line-height: normal;
    color: #666666;
    margin-right: 20px;
  }
  &_list {
    display: flex;
    gap: 16px;
    &_item {
      height: 32px;
      padding: 6px 8px;
      border-radius: 4px;

      font-size: 14px;
      font-weight: 350;
      line-height: normal;
      color: #666666;
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
    }
    .active {
      background: #f2f3f5;
      color: #262626;
      font-weight: normal;
    }
  }
}
</style>
